import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
import React from "react";
import styles from "@xo-union/tk-css-grid/lib/styles.css";
import PropTypes from "prop-types";

var Row = function Row(_ref) {
  var _context;

  var children = _ref.children,
      noGutters = _ref.noGutters,
      className = _ref.className,
      ComponentToRender = _ref.as,
      props = _objectWithoutProperties(_ref, ["children", "noGutters", "className", "as"]);

  var containerClass = _concatInstanceProperty(_context = "".concat(styles.row, " ")).call(_context, className);

  if (noGutters) {
    containerClass += " ".concat(styles['no-gutters']);
  }

  return React.createElement(ComponentToRender, _extends({
    className: containerClass
  }, props), children);
};

Row.defaultProps = {
  noGutters: false,
  className: '',
  as: 'div'
};
process.env.NODE_ENV !== "production" ? Row.propTypes = {
  /**
   * Component to render
   */
  as: PropTypes.elementType,
  noGutters: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node
} : void 0;
export default Row;